import {
  ApartmentOutlined,
  DashboardOutlined,
  FlagOutlined,
  GoldOutlined,
  IdcardOutlined,
  UnorderedListOutlined,
  DownOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Link, Outlet, useLocation } from "react-router-dom";
import { permissionAbility } from "../../helpers/permissionHelpers";

const paths = [
  { path: "/settings/general/org-levels", key: "1" },
  { path: "/settings/general/designations", key: "2" },
  { path: "/settings/general/plan-templates", key: "3" },
  { path: "/settings/general/plan-groups", key: "4" },
  { path: "/settings/general/plan-attributes", key: "5" },
  { path: "/settings/general/dropdown-attributes", key: "7" },
  { path: "/settings/general/scales", key: "6" },
  { path: "/settings/general/security", key: "8" },
];

function General() {
  const proHeight = document.body.clientHeight;
  const [mainKey, setMainKey] = useState("");
  let curLocation = useLocation();
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    setMainKey("");
    paths.forEach((path) => {
      if (path.path === curLocation.pathname) {
        setMainKey(path.key);
      } else if (curLocation.pathname.split("/")[3] === "plan-templates") {
        setMainKey("3");
      }
    });
  }, [curLocation]);

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <div className="flex">
          <div
            style={{
              height: proHeight - 64,
              overflow: "auto",
            }}
            className="w-48 border-r custom-scroll"
          >
            <div
              className="shadow-sm border-b text-lg pri-font"
              style={{ padding: "14px 24px", backgroundColor: "#fff" }}
            >
              General
            </div>
            <Menu
              className="transparent-scroll"
              mode="inline"
              selectedKeys={[mainKey]}
            >
              {permissionAbility(userLevel, "org-level", "view") && (
                <Menu.Item key="1" icon={<ApartmentOutlined />}>
                  <Link to="/settings/general/org-levels">Org Levels</Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "designations", "view") && (
                <Menu.Item key="2" icon={<IdcardOutlined />}>
                  <Link to="/settings/general/designations">Designations</Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "plan-templates", "view") && (
                <Menu.Item key="3" icon={<FlagOutlined />}>
                  <Link to="/settings/general/plan-templates">
                    Plan Templates
                  </Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "plan-groups", "view") && (
                <Menu.Item key="4" icon={<GoldOutlined />}>
                  <Link to="/settings/general/plan-groups">Plan Groups</Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "plan-attributes", "view") && (
                <Menu.Item key="5" icon={<UnorderedListOutlined />}>
                  <Link to="/settings/general/plan-attributes">
                    Plan Attributes
                  </Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "plan-attributes", "view") && (
                <Menu.Item key="7" icon={<DownOutlined />}>
                  <Link to="/settings/general/dropdown-attributes">
                    Dropdown Attributes
                  </Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "scales", "view") && (
                <Menu.Item key="6" icon={<DashboardOutlined />}>
                  <Link to="/settings/general/scales">Scales</Link>
                </Menu.Item>
              )}
              {permissionAbility(userLevel, "org-level", "view") && (
                <Menu.Item key="8" icon={<SafetyCertificateOutlined />}>
                  <Link to="/settings/general/security">Security</Link>
                </Menu.Item>
              )}
            </Menu>
          </div>
          <div className="w-full">
            <Outlet />
          </div>
        </div>
      </Content>
    </>
  );
}

export default General;
